import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import ParametersList from "../../components/Lists/SecurityParametersList";
//Import actions redux
import { getParameters } from "../../store/actions";

class Parameters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      params: null,
      //   nextid: 0
    };
  }

  componentDidMount() {
    this.props.getParameters(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetPARAM === false &&
      prevProps.loadingGetPARAM === true
    ) {
      console.log("componentdidmount", this.props.param);
      let param = this.props.param;
      if (param) {
        this.prepareData(param);
      }
    }
  }

  prepareData(param) {
    this.setState({ params: param });
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ params: null });
    this.props.getParameters(this.state.user);
  }

  newParameter(event) {
    event.preventDefault();
    this.props.history.push({
      pathname: "/createparameter",
      query: { origin_path: "/parameters" },
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Button
                  className="btn btn-primary buttonStatus usersButtons"
                  onClick={(event) => this.refresh(event)}
                  color="primary"
                >
                  <i size="lg" className="mdi  mdi-refresh"></i>
                </Button>
                {this.props.param != null && this.props.param.length === 0 ? (
                  <Button
                    className="btn btn-primary waves-effect waves-light  usersButtons"
                    onClick={(event) => this.newParameter(event)}
                  >
                    {"Crear nuevo parámetro"}
                  </Button>
                ) : null}
                <Card>
                  <CardBody>
                    <ParametersList params={this.state.params} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetPARAM, loadingGetPARAM, param, successPARAM } =
    state.getPARAM;
  return { errorGetPARAM, loadingGetPARAM, param, successPARAM };
};

export default withRouter(
  connect(mapStateProps, {
    getParameters,
  })(withNamespaces()(Parameters))
);
